import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function ConfirmDialog({ state, onDone }) {
  const close = (ok) => { state?.resolve(ok); onDone(); };
  return (
    <AlertDialog open={!!state} onOpenChange={(o) => !o && close(false)}>
      <AlertDialogContent data-testid="confirm-dialog" className="bg-card border-border rounded-2xl z-[80]">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">{state?.title}</AlertDialogTitle>
          {state?.description && <AlertDialogDescription>{state.description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel-btn" className="rounded-xl">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-action-btn" onClick={() => close(true)} className="rounded-xl bg-red-600 hover:bg-red-700 text-white">
            {state?.actionLabel || "Confirm"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
